import type { GridAccessApprovalDisplayMode } from '~/services-v2/financial-bff/__generated__/zeus'

export type AccessOpinionMode = `${GridAccessApprovalDisplayMode}`

export interface InstallationLocation {
  city: string
  state: string
}

export function normalizeInstallationLocation(city?: string | null, state?: string | null): InstallationLocation | null {
  const normalizedCity = (city ?? '').trim().replace(/\s+/g, ' ')
  const normalizedState = (state ?? '').trim().toUpperCase()

  if (!normalizedCity || !normalizedState)
    return null

  return { city: normalizedCity, state: normalizedState }
}

// Fail open: any error of the requirement query shows the field as optional (AC-20).
export function resolveAccessOpinionMode(result: {
  hasLocation: boolean
  isError: boolean
  displayMode?: AccessOpinionMode | null
}): AccessOpinionMode | null {
  if (!result.hasLocation)
    return null

  if (result.isError)
    return 'SHOW'

  return result.displayMode ?? null
}
